import React, { Component } from "react";
import PropTypes from "prop-types";
import cn from "classnames";
import { connect } from "react-redux";
import SchemaForm from "./SchemaForm";
import TypeUtils from "../lib/TypeUtils";
import FormUtils from "../lib/FormUtils";
import utils from "../lib/utils";
import { save } from "../actions/content";

import Loading from "./Loading";
import Switch from "./fields/Switch";

@connect((state, props) => {
  if (props.type && props.model) return {};

  const { params } = props.match;
  const type = state.types.find(type => type.slug === params.type);

  if (!type || !state.content[type.id]) {
    return {};
  }

  const model = params.id
    ? state.content[type.id].find(c => c.id === params.id)
    : props.location.state && props.location.state.fromModel
      ? props.location.state.fromModel
      : { active: true };

  return { type, model };
})
export default class EditContentInline extends Component {
  static contextTypes = {
    site: PropTypes.object.isRequired
  };

  state = {
    active: this.props.model ? this.props.model.active : false,
    selected: true
  };

  componentWillReceiveProps(props) {
    if (!props.model) return;

    if (this.props.model !== props.model.active) {
      this.setState({ active: props.model.active });
    }
  }

  getSchema() {
    const { model, type } = this.props;
    if (!type) return null;
    return FormUtils.getContentSchema(type, model);
  }

  onChangeActive = checked => {
    this.setState({ active: checked });
  };

  onToggle = e => {
    e.preventDefault();
    this.setState(prevState => ({ selected: !prevState.selected }));
  };

  render() {
    const schema = this.getSchema();
    const {
      fieldContext,
      formRef,
      model,
      type,
      isDragging,
      connectDragSource,
      connectDragPreview,
      onChange,
      onRemove
    } = this.props;
    const { selected } = this.state;

    if (!model) {
      return <Loading type="container" />;
    }

    return connectDragPreview(
      <div className={cn("edit-content inline", { placeholder: isDragging })}>
        <div className={cn("header", { selected })} onClick={this.onToggle}>
          {connectDragSource(<div className="handle" />)}
          <span className="type-name">{type.name}</span>
          <button
            type="button"
            className="ion-ios-minus-outline"
            onClick={onRemove}
          />
        </div>
        <SchemaForm
          formRef={formRef}
          button={null}
          className="form"
          component="div"
          context={fieldContext}
          schema={schema}
          value={model}
          onChange={onChange}
        >
          <Switch
            key="active"
            value={this.state.active}
            onChange={this.onChangeActive}
          />
        </SchemaForm>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/EditContentInline.js